import ImgUpload from './src/main'

ImgUpload.install = function (Vue) {
    Vue.components(ImgUpload.name, ImgUpload)
}

export default ImgUpload